import "../../App.css";

const Divider = ({
    style = {}
}) => {
    return (
        <hr className="m-0 w-auto" style={{ color: "#e2e7f1", border: "0.1px solid #e2e7f1", ...style }} />
    );
};

export default Divider;